(() => {
  angular
    .module('app.campaign')
    .controller('CampaignTrackingPointsController', CampaignTrackingPoints);

  CampaignTrackingPoints.$inject = [
    '$scope',
    'ModalService',
    'EventsService',
    'CampaignService',
    'CampaignManagerService',
  ];

  function CampaignTrackingPoints(
    $scope,
    ModalService,
    EventsService,
    CampaignService,
    CampaignManagerService,
  ) {
    const vm = this;
    vm.campaign = CampaignManagerService.getCampaignData();

    vm.buttonDisabled = type => {
      if (type === 'export') {
        return vm.trackpointList.getCheckedTrackpoints().length === 0;
      }

      if (type !== 'add' && !vm.trackpointList.isAnyChecked()) {
        return true;
      }

      return false;
    }



    /* ---------------------------------------------------- */
    /*  Trackpoint list in create/edit page                 */
    /* -----------------------------------------------------*/
    vm.campaignsADH = [];
    vm.isTrackpointADH = tp => tp.provider === 'adh';
    vm.getTrackpointADHType = tp => {
      switch(tp.type) {
        case 'io': return 'Insertion Order';
        case 'li': return 'Line Item';
        default: return 'Campaign';
      }
    };

    vm.hasCheckedTrackpointADH = () => (
      vm.trackpointList.getCheckedTrackpoints().length !== 0 &&
      vm.trackpointList.getCheckedTrackpoints().some(tp => vm.isTrackpointADH(tp)));

    const updateMixedTrackpoints = () => {
      vm.mixedTrackpoints = [
        ...vm.campaign.trackpoints,
      ];

      CampaignManagerService.setMixedTrackpoints(vm.mixedTrackpoints);
    };



    /* -------------------------------------- */
    /* Activation                             */
    /* -------------------------------------- */
    activate();

    function activate() {
      vm.dataLoaded = true;
      vm.mixedTrackpoints = [
        ...vm.campaign.trackpoints,
      ];
    }



    /* -------------------------------------- */
    /* List                                   */
    /* -------------------------------------- */
    vm.trackpointList = {
      getCheckedTrackpoints: () => {
        if (angular.isUndefined(vm.campaign)) {
          return [];
        }

        return vm.mixedTrackpoints.filter(tp => tp.$$checked);
      },

      checkAll: () => {
        const isAllChecked = vm.trackpointList.isAllChecked();
        _.each(vm.mixedTrackpoints, tp => {
          tp.$$checked = !isAllChecked;
        });
      },

      isAllChecked: () => {
        if (angular.isUndefined(vm.campaign) ||
          angular.isUndefined(vm.mixedTrackpoints) ||
          !vm.mixedTrackpoints.length) {
          return false;
        }

        return _.every(vm.mixedTrackpoints, tp => tp.$$checked);
      },

      isAnyChecked: () => {
        if (angular.isUndefined(vm.campaign)) {
          return false;
        }

        return _.some(vm.mixedTrackpoints, tp => tp.$$checked);
      },

      isAddressableTV: () => $('#current-user').data('feature-tv') === 1,

      isAddressableTVEnabled: trackpoint => {
        if (!trackpoint.properties) {
          return false;
        }

        const { featureTV, featureTVEnabled } = trackpoint.properties;
        return featureTV === 'on' || featureTVEnabled === 1;
      }
    };

    vm.getUrl = (tp, eventType) => EventsService.getUrl(tp, eventType);
    vm.getLabelName = eventType => EventsService.getLabelName(eventType);

    vm.getUrls = tp => {
      let urls = '';

      angular.forEach(tp.eventTypes, (isEnabled, eventType) => {
        if (isEnabled) {
          urls += vm.getUrl(tp, eventType) + '\n';
        }
      });

      return urls;
    };

    $scope.onClipboardSuccess = () => {
      Notification.showSimpleSuccessMessage(`
        You’ve copied a tracking pixel to the clipboard. If you need help with implementing it, take a look at our
        <a href="https://helpdocs.audiencereport.com/article/y753xy25r5-what-is-event-tracking" target="_blank">FAQ</a>`,
        'Copied to clipboard', 5);
    };

    $scope.onAllClipboardSuccess = () => {
      Notification.showSimpleSuccessMessage(`
        You’ve copied a list of tracking pixels to the clipboard. If you need help with implementing them, take a look at our
        <a href="https://helpdocs.audiencereport.com/article/y753xy25r5-what-is-event-tracking" target="_blank">FAQ</a>`,
        'Copied to clipboard', 5);
    };

    $scope.onClipboardError = () => {
      Notification.showSimpleError('Copying to clipboard is not supported in your browser');
    };

    /* -------------------------------------
     Add trackpoint(s) modal
     ---------------------------------------*/
    vm.openAddModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/add.html?v=${window.BUILD_VERSION}`,
          controller: 'AddTrackpointModalController',
          controllerAs: 'addModal',
          inputs: {
            currentCampaign: vm.campaign
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {});
        });
    };

    /* -------------------------------------
     Delete trackpoint(s) modal
     ---------------------------------------*/
    vm.openDeleteModal = trackpoint => {
      let selectedSourcesADH = [];
      let selectedTrackpoints = [];

      if (trackpoint) {
        if (vm.isTrackpointADH(trackpoint)) {
          selectedSourcesADH = [trackpoint];
        } else {
          selectedTrackpoints = [trackpoint];
        }
      } else {
        selectedTrackpoints = vm.trackpointList.getCheckedTrackpoints();
      }

      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/delete.html?v=${window.BUILD_VERSION}`,
          controller: 'DeleteTrackpointModalController',
          controllerAs: 'deleteModal',
          inputs: {
            currentCampaign: vm.campaign,
            selectedSourcesADH,
            selectedTrackpoints,
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {});
        });
    };

    /* -------------------------------------
     Email trackpoint(s) modal
     ---------------------------------------*/
    vm.openEmailModal = trackpoint => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/email.html?v=${window.BUILD_VERSION}`,
          controller: 'EmailTrackpointModalController',
          controllerAs: 'emailModal',
          inputs: {
            currentCampaign: vm.campaign,
            selectedTrackpoints: trackpoint ? [trackpoint] : vm.trackpointList.getCheckedTrackpoints()
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {});
        });
    };

    /* -------------------------------------
     Edit events for trackpoint(s) modal
     ---------------------------------------*/
    vm.openEditEventsModal = trackpoint => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/events.html?v=${window.BUILD_VERSION}`,
          controller: 'EditEventsTrackpointModalController',
          controllerAs: 'eventsModal',
          inputs: {
            currentCampaign: vm.campaign,
            selectedTrackpoints: trackpoint ? [trackpoint] : vm.trackpointList.getCheckedTrackpoints()
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {});
        });
    };

    /* -------------------------------------
     Rename trackpoint modal
     ---------------------------------------*/
    vm.openRenameModal = trackpoint => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/rename.html?v=${window.BUILD_VERSION}`,
          controller: 'RenameTrackpointModalController',
          controllerAs: 'renameModal',
          inputs: {
            selectedTrackpoint: trackpoint
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {});
        });
    };

    /* -------------------------------------
     Addressable TV measurement settings modal
     ---------------------------------------*/
    vm.openTVModal = trackpoint => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/addressableTV.html?v=${window.BUILD_VERSION}`,
          controller: 'AddressableTVTrackpointModalController',
          controllerAs: 'tvModal',
          inputs: {
            campaign: vm.campaign,
            selectedTrackpoints: trackpoint ? [trackpoint] : vm.trackpointList.getCheckedTrackpoints(),
            onSave: () => {}
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {});
        });
    }

    /* -------------------------------------
     Add youtube (ADH) trackpoint(s) modal
     ---------------------------------------*/
     vm.openAddYoutubeModal = () => {
      ModalService
        .showModal({
          templateUrl: `../../assets/js/app/campaign/modals/trackpoint/add.adh.html?v=${window.BUILD_VERSION}`,
          controller: 'AddTrackpointYoutubeModalController',
          controllerAs: 'addYoutubeModal',
          inputs: {
            currentCampaign: vm.campaign,
            campaignsADH: vm.campaignsADH,
          }
        }).then(modal => {
          modal.element.modal();
          modal.close.then(result => {});
        });
    };

    /* -------------------------------------
     Export to CSV
     ---------------------------------------*/
    vm.exportToCsv = () => {
      const comma = ',';

      const trackpoints = vm.mixedTrackpoints.filter(item => item.$$checked);
      const getEnableEvents = types => Object.entries(types)
        .reduce((memo, [key, value]) => value ? {
          ...memo,
          [key]: value,
        } : memo, {});

      const eventsColumns = Object.keys(
        trackpoints
          .map(({ eventTypes }) => getEnableEvents(eventTypes))
          .reduce((memo, items) => ({
            ...memo,
            ...items,
          }), {}));

      const getHeader = () => {
        const format = (name, item) => `${name}: ${EventsService.getLabelName(item)}`;
        const template =  title => eventsColumns.reduce((memo, item) => ([...memo, format(title, item)]), []);
        const columns = [
          'Trackpoint name',
          'Trackpoint code',
          ...template('Pixel'),
          ...template('HTML'),
          'Script HTML tag (impression + viewability)',
          'Script URL (impression + viewability)',
        ];

        return `${columns.join(comma)}\r\n`;
      };

      const getEvents = events => Object.keys(getEnableEvents(events))
        .reduce((memo, key) => [...memo, key], []);

      const toCSV = trackpoints
        .map(item => ({
          name: item.name,
          code: `${item.cid}${item.tailcode}`,
          events: getEvents(item.eventTypes),
        }));

      const row = item => {
        const eventParam = event => event === 'impression' ? '' : `&event=${event}`;
        const analyticsUrl = 'https://visitanalytics.userreport.com';
        const scriptUrl = `${analyticsUrl}/hit.js?t=${item.code}&event=impression`;
        const scriptHtml = `<script src="${scriptUrl}"></script>`;

        const format = type => eventsColumns.reduce((memo, event) => {
          const url = `${analyticsUrl}/hit.gif?t=${item.code}${eventParam(event)}`
          const template = type === 'pixel' ? url : `<img src="${url}" />`;

          return [
            ...memo,
            item.events.includes(event) ? template : '',
          ];
        }, []);

        const cells = [
          item.name,
          item.code,
          ...format('pixel'),
          ...format('html'),
          scriptHtml,
          scriptUrl,
        ];

        return `${cells.join(comma)}\r\n`;
      };

      const csv = toCSV.reduce((memo, item) => (memo + row(item)), getHeader());

      const today = new Intl.DateTimeFormat('en', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      }).format(new Date()).replace(/\//g, '');

      const link = document.createElement('a');
      link.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
      link.target = '_blank';
      link.download = `trackpoints-${vm.campaign.name}-${today}.csv`;
      link.click();
    };

    /* -------------------------------------
     Close hint
     ---------------------------------------*/
     vm.hintClose = () => {
       vm.hintClosed = true;
     }

    /* Persist changes to service */
    $scope.$watch(() => vm.campaign,
      campaign => {
        CampaignManagerService.setCampaignData(campaign);

        if (CampaignManagerService.isCampaignFieldChanged('trackpoints')) {
          CampaignManagerService.showTechedgeNotification(campaign);
        }
      }, true);

    $scope.$watch(() => vm.campaign && vm.campaign.sources,
      () => {
        updateMixedTrackpoints();
      }, true);

    $scope.$watch(() => vm.campaign && vm.campaign.trackpoints,
      () => {
        updateMixedTrackpoints();
      }, true);
  }
})();
